import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { PureComponent } from 'react'
import { ExploreHeader } from './header/header'
import Grid from 'shared/components/search/grid'

const { shape, string, bool, number } = PropTypes

export default class Explore extends PureComponent {
    static propTypes = {
        search: shape({
            term: string.isRequired,
            total: number.isRequired,
            sorting: string,
            suggestion: string,
            suggestionUrl: string,
            isSticker: bool.isRequired,
        }),
    }
    render() {
        const { search, searchResponseId, error } = this.props
        const searchInfo = { ...search, ...{ error } }
        return (
            <div>
                <ExploreHeader
                    searchInfo={searchInfo}
                    searchResponseId={searchResponseId}
                    isSticker={searchInfo.isSticker}
                    term={search.displayTerm}
                />
                <Grid />
            </div>
        )
    }
}
